import {
    ACTION_GET_TEST_SUCCEEDED,
    ACTION_GET_TEST_STARTED,
    ACTION_GET_TEST_FAILED,
    ACTION_POST_TEST_SUCCEEDED
} from "../actions/actionTypes";

export default function (state = [], action) {
    switch (action.type) {
        case ACTION_GET_TEST_SUCCEEDED:
            return action.testJSON;
        case ACTION_GET_TEST_STARTED:
        case ACTION_GET_TEST_FAILED:
            return [];
        case ACTION_POST_TEST_SUCCEEDED:
            return state;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/test_content.js